<template>
  <div>
    <div class="form_block" v-if="form &&!sorry">
    <FormulateForm
    class="login-form"
    v-model="formValues"
    @submit="submitForm"
    name="contactform"
    >
    <h2 class="form-title">Leave your contact details to receive 2 months FREE trial!</h2>
    <div class="double-wide">
    <FormulateInput
    name="name"
    type="text"
    placeholder="Name*"
    validation="required"
    />
    <FormulateInput
    name="email"
    type="email"
    placeholder="Email*"
    validation="required|email"
    />
    </div>
    <div class="double-wide">
    <FormulateInput
    name="designation"
    type="text"
    placeholder="Title/Position"
    />
    <FormulateInput
    name="location"
    type="text"
    placeholder="City/Country"
    />
    </div>
    <FormulateInput
    type="textarea"
    name="comment"
    placeholder="Comment"
    />
    <FormulateInput
    type="submit"
    label="Submit"
    >
    <span class="loader" v-if="loading" /></FormulateInput>
    <!-- <pre
    class="code"
    v-text="formValues"
    /> -->
    </FormulateForm>
    </div>
    <div class="thankyou" v-if="!form &&!sorry">
        <!-- <img class="close" src="@/assets/ude/closed.png"> -->
        <div class="center">
        <p class="thank-t">Thank you!</p>
        <p class="thank-st">Redeem the code on App Store
            to activate your <span class="cblue">free two-month </span>
            trials.</p>
            <img class="gift" src="@/assets/ude/gift.png">
            <p>your promotion code </p>
            <p class="cblue">{{promotion_code}}</p>
            <p class="last">*The promotion code is also sent to your email.</p>
        </div>
        <!-- thankyou -->
    </div>
    <div class="sorry" v-if="sorry">
        <!-- sorry -->
        <!-- <img class="close" src="@/assets/ude/closed.png"> -->
        <div class="center">
        <p class="thank-t">Sorry :(</p>
        <p class="thank-st">The free trial event has concluded.
            If you would like more information, please contact us.</p>
            <img class="gift" src="@/assets/ude/timeout.png">
          <a href="http://www.ebmtech.com/en/contact/index.php"><p class="cblue ptt-30">Contact us ></p></a>
        </div>
    </div>
    </div>
</template>

<script>
import axios from 'axios'
export default {
  data()
  {
  return{
      snackbar: false,
      formValues: {
      },
      form:true,
      sorry:false,
      promotion_code:'',
      loading:false,
    }
  },
  methods:{
      async submitForm(){
        this.loading = true;
        //calling post request to api 
        let formData = new FormData();
        formData.append("name", this.formValues.name);
        formData.append("email", this.formValues.email);
        formData.append("designation", this.formValues.designation);
        formData.append("location", this.formValues.location);
        formData.append("comment", this.formValues.comment);
        try {
              const res = await axios.post('https://fhrweb.ebmtech.com/net/api/UDEProFeedbacks',formData)
              console.log(res);
              this.loading = false;
              if(res.data.promotioN_ID == null)
              {
                console.log("null promotioN_ID");
                this.sorry = true
              }
              else{
                this.form = false
                this.promotion_code = res.data.promotioN_ID
              }
              this.$formulate.reset('contactform')
        } 
        catch (err) {
          this.loading = false;
          console.log("error", err.response);
              this.$formulate.handle(err, 'contactform')
        }
      },
      // clearForm(){
      //   this.formValues.name ='';
      //   this.dropboxForm.product ='';
      //   this.formValues.telephone ='';
      //   this.dropboxForm.message ='';
      //   this.formValues.email ='';
      //   this.dropboxForm.createDate =''
      // },
  }
}
</script>

<style scoped>
p{
    color: white;
}
.contact_title3{
    font-size: 20px;
    color: #2A2F35;
}
.contact_title2{
    margin-top: 13px;
    font-size: 20px;
    color: #2A2F35;
}
.contact_title1{
    color: #2A2F35;
    margin-top: 50px;
}
.contact_block{
    height: 207px;
    background: #F8F8F8 0% 0% no-repeat padding-box;
}
.login-form {
  margin:auto;
  /* margin-left: 280px; */
  padding: 20px ;
  /* border: 1px solid #a8a8a8; */
  border-radius: .5em;
  max-width: 1500px;
  box-sizing: border-box;
}
.center{
    text-align: center;
}
.form_block{
  max-width: 800px;
  margin: auto;
  padding-top: 50px;
  /* margin-left: 180px;
  margin-right: 180px; */
  /* height: 604px; */
}
.thankyou{
    margin:auto;
    max-width: 920px;
    height: 427px;
    /* background: #33373B; */
    border-radius: 5px;
}
.cursor{
    cursor: pointer;
}
.thank-st{
    margin:auto;
    padding-top: 12px;
    width: 310px;
    font-style: normal;
font-weight: normal;
font-size: 18px;
line-height: 21px;
}
.ptt-30{
    padding-top: 30px;
}
.cblue{
    color: #00B8F6;
}
.gift{
    padding-top: 40px;
}
.thank-t{
    margin: auto;
    width: 166px;
    font-style: normal;
font-weight: 600;
font-size: 32px;
line-height: 38px;
padding-top: 33px;
}
.last{
    padding-top: 2px;
    font-style: normal;
font-weight: normal;
font-size: 14px;
line-height: 16px;
}
.close{
    float:right;
    padding: 23px;
}
.form-title {
    color: #FFFFFF;
  margin-bottom: 1em;
  font-style: normal;
font-weight: 600;
font-size: 24px;
line-height: 28px;
}
.double-wide .formulate-input:first-child{
  margin-bottom: 16px;
}
.login-form::v-deep .formulate-input .formulate-input-element {
  max-width: none;
}
.login-form::v-deep .formulate-input .formulate-input-element--textarea textarea{
  height: 54px;
  color: #FFFFFF;
}
.login-form::v-deep .formulate-input button{
    border: 1px solid #00beff;
    background-color: #00beff;
    width: 108px;
    height: 38px;
    border-radius: 0em;
}
.login-form .formulate-input button {
    border-radius: 5px !important;
}
.login-form::v-deep .formulate-input input{
  color: white;
}
.login-form::v-deep .formulate-input input:focus{
   color: white;
}
.login-form::v-deep .formulate-input button:hover{
  background-color: #2A2F35;
}
.login-form::v-deep .formulate-input-element--submit--label{
    margin: auto;
}
@media screen and (max-width: 960px){

.thankyou{
    width: 100% !important;
}
}
@media (min-width: 420px) {
  .double-wide {
    display: flex;
  }
  .double-wide .formulate-input {
    flex-grow: 1;
    width: calc(50% - .5em);
  }
  .double-wide .formulate-input:first-child {
    margin-right: .5em;
  }
  .double-wide .formulate-input:last-child {
    margin-left: .5em;
  }
}
@media (max-width: 464px){
  .form_block{
  margin-left: 0px;
  margin-right: 0px;
}
  .contact_block{
    height: 237px;
}
.contact_title2{
    font-size: 16px;
    margin-left: 12px;
    margin-right: 12px;
}
}
</style>